export default __webpack_public_path__ + "static/media/reading.bbd2fbcd.svg";